import { defineMessages } from 'react-intl';

const translations = {
  breadcrumb: {
    settings: {
      id: 'pages.viewFulfilmentLocation.breadcrumb.settings',
      defaultMessage: 'Settings',
      description: 'label of the settings breadcrumb',
    },
    fulfilmentLocations: {
      id: 'pages.viewFulfilmentLocation.breadcrumb.fulfilmentLocations',
      defaultMessage: 'Fulfilment locations',
      description: 'label of the fulfilment locations breadcrumb',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.viewFulfilmentLocation.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details sub navigation tab',
    },
    positions: {
      id: 'pages.viewFulfilmentLocation.subNavigation.positions',
      defaultMessage: 'Positions',
      description: 'label of the positions sub navigation tab',
    },
    sorting: {
      id: 'pages.viewFulfilmentLocation.subNavigation.sorting',
      defaultMessage: 'Sorting',
      description: 'label of the sorting sub navigation tab',
    },
  },
  primaryAction: {
    add: {
      label: {
        id: 'pages.viewFulfilmentLocation.primaryAction.add.label',
        defaultMessage: 'Add',
        description: 'Title of the add button of the fulfilment location positions',
      },
    },
    addMultiple: {
      label: {
        id: 'pages.viewFulfilmentLocation.primaryAction.addMultiple.label',
        defaultMessage: 'Add multiple',
        description: 'Title of the add multiple button of the fulfilment location positions',
      },
    },
  },
  unknownLocation: {
    message: {
      id: 'pages.viewFulfilmentLocation.unknownLocation.message',
      defaultMessage: 'This location does not exist',
      description: 'message when an unknown location is reached',
    },
    title: {
      id: 'pages.viewFulfilmentLocation.unknownLocation.title',
      defaultMessage: 'Unknown location',
      description: 'title of an unknown location page',
    },
  },
  deletedMessage: {
    id: 'pages.viewFulfilmentLocation.deletedMessage',
    defaultMessage: 'This fulfilment location has been deleted.',
    description: 'Delete message of the fulfilment location',
  },
  confirmDelete: {
    title: {
      id: 'pages.fulfilmentLocations.confirmDelete.title',
      defaultMessage: 'Delete fulfilment location',
      description: 'Title of the delete fulfilment location confirm',
    },
    description: {
      id: 'pages.fulfilmentLocations.confirmDelete.description',
      defaultMessage: 'Are you sure you want to delete this ',
      description: 'description of the delete fulfilment location confirm',
    },
    buttons: {
      delete: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'label of the delete button',
      },
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel button',
      },
    },
  },
  feedback: {
    fulfilmentLocationDeleted: {
      id: 'pages.fulfilmentLocations.feedback.fulfilmentLocationDeleted',
      defaultMessage: 'Fulfilment location delete',
      description: 'feedback message when the location was delete',
    },
    fulfilmentLocationNotDeleted: {
      id: 'pages.fulfilmentLocations.feedback.fulfilmentLocationNotDeleted',
      defaultMessage: 'Could not delete fulfilment location',
      description: 'feedback message when the location could not be delete',
    },
  },
  actions: {
    delete: {
      id: 'actions.delete',
      defaultMessage: 'Delete',
      description: 'label of the delete action',
    },
  },
};

export default defineMessages(translations);
